<template>
    <div class="po" >
        <el-form :inline="true" :model="formInline" v-if="path==='/启动页管理'?false:true">
                    <el-form-item :label="neiname">
                            <el-input v-model="formInline.name" :placeholder="neiname"></el-input>
                    </el-form-item>
                <el-form-item :label="neitiem">
                    <el-date-picker
                        v-model="formInline.data"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy 年 MM 月 dd 日"
                        value-format="timestamp"
                        :default-time="['00:00:00', '23:59:59']"
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item v-if="path==='/作文题目发放'|| path==='/优秀作文展示'?true:false">
                   <el-select v-model="formInline.status" placeholder="请选择">
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
                </el-form-item>
                    <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>

     </el-form>
           <el-button v-if="path==='/词库管理'|| path==='/文章管理' ||role ==='admin'&& (path==='/作文题目发放'|| path==='/优秀作文展示')?false:true" type="primary" @click="add">添加</el-button>
           <dia :dialog="dialog"></dia>
    </div>
</template>
<script>
import dia from '@/components/li-dialog'
  import {
    mapState,
    mapMutations,
    mapActions
  } from 'vuex'
export default {
   name: 'Topmenu',
   props:['path','page'],
   components: {
    dia
   },
    data () {
        return {
          neiname:'',
          role:'',
          path:'',
          neitiem:'',
            formInline: {
                    name: '',
                    data: '',
                    status: undefined
                   
            }, 
              dialog:{
                dialogFormVisible:false,
                title:"",
                url:{
                  stauts:'添加'
                },
                form:{
                  '词语名称':'',
                  '拼音':'',
                  '星级':1,
                  audio:'',
                  checkpointId:'',
                },
             
                id:''
            },
            options:[
              {
                value:0,
                label:'发布'
              },
              {
                value:1,
                label:'下架'
              },
              {
                value:undefined,
                label:'全部'
              }
            ]
        }
    },
    methods: {
       ...mapActions('managlist', ['FETCH_CHECKPOINT_LIST','FETCH_WORD_LIST','FETCH_ARTICLE_STAR','FETCH_ARTICLE_LIST','FETCH_STARTUPPAGE_LIST','FETCH_COMPOSITION_LIST','FETCH_AWESOMECOMPOSITION_LIST']),
      ...mapMutations('managlist',['find']),
      async changeIndex(path,data){
       console.log('dadawdawda',data)
        switch (path) {
        case '/词库管理':
            // console.log('addadsaas',data)
            console.log(data)
           await this.FETCH_CHECKPOINT_LIST(data)
        //    console.log(this.wordList)
            break;
        case '/词库查看':
           if (data) {
             console.log(data)
               data.id = this.$route.query.id
              await   this.FETCH_WORD_LIST(data)
           }else{
                await   this.FETCH_WORD_LIST( {id:this.$route.query.id})
           }
           
            break;
        case '/文章管理':
          console.log('1111')
          await  this.FETCH_ARTICLE_STAR(data)
            
            break;
        case '/文章查看':
          console.log(data)
          if (data) {
          
              data.star = this.$route.query.star
              data.keyword = data.name
         
              await console.log('121211',data)
            await this.FETCH_ARTICLE_LIST(data)
          }else{
              await this.FETCH_ARTICLE_LIST({star:this.$route.query.star})
          }
            // this.article.star = sessionStorage.setItem('articlStar',JSON.stringify(this.$route.query.star)) 
        
             
                
            
            break
      
        case '/启动页管理':
          await  this.FETCH_STARTUPPAGE_LIST(data)
         
            break;
       
        case '/作文题目发放':
          await  this.FETCH_COMPOSITION_LIST(data)
       
  
            break;
       
        case '/优秀作文展示':
         await   this.FETCH_AWESOMECOMPOSITION_LIST(data)
            break;

    }
    
        },
     onSubmit(){
            // eslint-disable-next-line no-console
            console.log(this.formInline)
            this.changeIndex(this.path,this.formInline)
          this.find(this.formInline)
            this.formInline.beginTime=''
            this.formInline.endTime=''
        },
    add(){ 
      let row ={}
      switch (this.path) {
        case '/词库查看':
          this.dialog.form = {
                dialogFormVisible:false,
                title:"",
                url:{
                  stauts:'添加'
                },
                form:{
                  '词语名称':'',
                  '拼音':'',
                  audio:'',
                  checkpointId:'',
                },
             
                id:''
            }
          this.dialog.form.checkpointId = this.$route.query.id
           this.dialog.form.星级 = this.$route.query.star
           this.dialog.form.star = this.$route.query.star
           this.dialog.page = this.page
            console.log(this.dialog.form)
            this.dialog.dialogFormVisible = true
          break;

        case '/文章查看': 
        row.status = '添加'
        row.句子 = [
          {
            value:''
          }
        ]
        this.$router.push({name:'文章查看修改', query:{row:row}})
          break;
        case '/启动页管理':
         row.status = '添加'
         this.$router.push({name:'启动页查看', query:{row:row}})
         break;
        case '/作文题目发放':
             this.$router.push({
                                    name:'作文查看',
                                    query:{
                                        row: row
                                    }
                                }) 
          break;
        case '/优秀作文展示':
           this.$router.push({
                                    name:'优秀作文查看',
                                    query:{
                                        row:  row
                                    }
                                }) 
          break;
      }
    
    }
    },
    mounted () {
    
         this.role =JSON.parse( sessionStorage.getItem('role')).role
      console.log('啊啊啊啊啊啊啊啊啊啊啊啊',this.path)
     switch (this.path) {
       case '/词库管理':
         this.neiname = '关卡名称'
         break;
       case '/词库查看':
         this.neiname = '词语名称'
         this.dialog.form.checkpointId  =this.$route.query.id
         break;
       case '/文章管理':
       this.neiname = '文章星级'
       break
       case '/文章查看':
       this.neiname = '文章名称'
         break;
      case '/作文题目发放':
        this.neitiem = '发布时间'
        this.neiname = '作文题目'
          break;
      case '/优秀作文展示':
         this.neitiem = '发布时间'
        this.neiname = '作文题目'
          break;
     }
    }
}
</script>
<style lang="scss" scoped>

</style>
